import { Injectable, Injector, ElementRef, Renderer2 } from '@angular/core';
import { MessagingService } from 'src/modules/base/shared/services/messaging.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LazyService } from 'src/app/lazy.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppAlertComponent } from 'src/modules/base/components/app-alert/app-alert.component';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AuthGuard } from 'src/modules/base/guards/auth.gaurd';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { AIService } from 'src/modules/base/components/aiml/services/ai.service';
import { FormService } from 'src/modules/base/components/form/form.service';
import { AccessibilityService } from 'src/modules/base/services/accessibility.service';
declare var pwaPrompt: any;

@Injectable({
  providedIn: 'root'
})
export class LoginServiceService {
  showLoginForm: boolean = false;
  private captchaObserver: MutationObserver;

  constructor(
    private messagingService: MessagingService,
    private authenticationService: AuthenticationService,
    private appService: AppService,
    private baseService: BaseService,
    public injector: Injector,
    private lazyService: LazyService,
    private alerts: AlertsService,
    private loader: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private utilService: UtilService,
    private bsModalService: BsModalService,
    private aiService: AIService,
    public preferenceService: PreferenceService,
    private formService:FormService,
    private accessibilityService: AccessibilityService
  ) { }

  initApplication() { }

  initService() {
    this.baseService.init('login');
    this.appService.setApplication(this.appService._appData.DEFAULT_APPLICATION); // make dynamic
    this.lazyService.loadLanguageFile(this.injector, () => { })
    //this.lazyService.loadJosnModule(injector, () => { });
    this.lazyService.loadAllLazyModules(this.injector, () => { });
  }

  decryptLoginInfo(data){
    if (data.resource != undefined && data.resource.length > 0) {
      var obj = data.resource[0];
       // let api_encryption_key = '',session_id = '',user_id = '', role_type = '', login_id = '';
        if (obj.extra_data?.newses) {
          obj['api_encryption_key'] = obj.extra_data?.newres
          obj['session_id'] = this.appService.decryptText(obj.extra_data?.newres, obj.extra_data?.newses);
          obj.user_id = this.appService.decryptText(obj.extra_data?.newres, obj.user_id);
          obj.role_type = this.appService.decryptText(obj.extra_data?.newres, obj.role_type);
          obj.login_id = this.appService.decryptText(obj.extra_data?.newres, obj.login_id);
          if(location.hostname == "localhost" && this.utilService.isMac() && this.utilService.isSafari()){
            this.appService.writeCookie("session_id",this.appService.decryptText(obj.extra_data?.newres, obj.extra_data?.newses));
          }
        }
      }
      return data
  }

  saveLoginInfo(data){
    if(data.resource != undefined && data.resource.length>0){
      var obj= data.resource[0];
      if(obj.api_encryption_key != undefined && obj.user_id != undefined){
        var userKey = this.appService.encryptText(obj.api_encryption_key,obj.user_id);
        this.storageService.setData("uuid",userKey,()=>{})
      }
      if (this.appService.checkNativeApp()) {
        this.baseService.nativeDataHandling("loggedin",{user_id:obj.user_id,session_id:obj.session_id});
      }
    }
  }

  buildApplication(data: any, menuParser: any) {
    this.saveLoginInfo(data);
    this.messagingService.initializeMessaging();
    this.authenticationService.setUser(data.resource[0]);
    var super_app_url = "/";
    if (data.resource[0] != undefined && data.resource[0].super_app_url != "" && data.resource[0].super_app_url != undefined) {
      super_app_url = data.resource[0].super_app_url;
    }

    if (this.appService._appData.APPLICATION_AWARE) {
      this.baseService.getMyApplication((response) => {
        /************** MENU DECORATOR ***********/
        if (response.menus != undefined && menuParser) {
          response.menus = menuParser.parseMenu(response, this.appService, this.injector);
        }
        /************** MENU DECORATOR ***********/
        this.appService.parseMyConfigObject(response);
        //this.appService.addWCAGEnabled(response);
        this.aiService.loadAgents();
        this.baseService.getMobileMenu();
        this.lazyService.loadAccountValues();

        /******** ADDING DYNAMIC MODULES  ********/
        if (response.dynamic_application != undefined && response.dynamic_application.length) {
          var paths = this.router.config;
          this.appService.buildDynamicApp(this.router, paths, response.dynamic_application, AuthGuard);
        }
        /******** ADDING DYNAMIC MODULES  ********/

        /******** ADDING NOCODE MODULES  ********/
        if (response.nocode_application != undefined && response.nocode_application.length) {
          var paths = this.router.config;
          this.appService.buildNocodeApp(this.router, paths, response.nocode_application, AuthGuard);
        }
        /******** ADDING NOCODE MODULES  ********/

        this.addNativeFCM();
        this.baseService.changeDashboardUrl();
        this.baseService.setFavIcon();
        this.loader.hideSpinner();

        
        var promises = [];
        promises.push(this.lazyService.getFacilityListPromise());
        promises.push(this.lazyService.loadAccountOnlyConfig());
        promises.push(this.lazyService.loadAccountConfig());


         Promise.all(promises).then(res => {
            this.appService.parseAsyncConfig(()=>{
              //no need to notify native app if patient
              if(this.authenticationService.getUserType() != "patient"){
                if(this.appService._currentSessionData.qrLoginPassed != undefined && this.appService._currentSessionData.qrLoginPassed != "" && this.appService._currentSessionData.qrLoginPassed != "true") { 
                  this.baseService.nativeDataHandling("config",JSON.parse(JSON.stringify(this.appService.getAccountConfigValueList())))
                }
              }else{
                this.appService.setAccountWebsiteVisibilityPatient()
              }
            })
            if (this.route.snapshot.queryParams.returnUrl != undefined) {
              if (super_app_url == "/")
                this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
              else {
                let url = this.route.snapshot.queryParams.returnUrl;
                this.baseService.redirect(url, "_self").then(() => { });
              }
            } else {
              if (super_app_url == "/")
                this.router.navigate([this.appService._appData.DEFAULT_APPLICATION + '/dashboard']);
              else {
                let url = window.location.origin + super_app_url + this.appService._appData.DEFAULT_APPLICATION + "/dashboard";
                this.baseService.redirect(url, "_self").then(() => { });
              }
            }
          });
        this.storageService.reloadOtherTab();
        this.messagingService.requestPermission(this.authenticationService.getCurrentUser()['user_id']);
        if (this.authenticationService.getUserType().toLowerCase() == 'patient') {
          this.storageService.setData('LoggedInUser', data.resource[0], () => {
            console.log('Logged In User Saved');
          });
          this.baseService.getPatientUHID().subscribe((res) => {
            if (res.resource != undefined && res.resource[0].tag_data != undefined) {
              this.storageService.getData('currentUser', (result) => {
                result['tag_data'] = res.resource[0].tag_data;
                this.storageService.setData('currentUser', result, () => {
                  console.log('Tag Data Saved In User');
                });
              });
            }
            if (res.resource[0].registrationType == "pre-registration") {
              this.storageService.setData("hasUhId", res.resource[0].preRegistrationNo, () => {
                console.log("preRegistrationNo data saved alredy")
              });
              this.storageService.setData("patientDetails", res.resource[0], (data) => {
                // console.log("Patient Details data saved alredy")
                // this.appService._currentSessionData.getPatientDetails = data;
              });
              this.storageService.setData("current_facility", { facility_id: res.resource[0].current_facility_id, facility_name: res.resource[0].current_facility_name }, () => {
                console.log("current facility details data saved alredy")
              })
            } else {
              this.storageService.setData("hasUhId", res.resource[0].uhId, () => {
                console.log("uhid data saved alredy")
              });
              this.storageService.setData("patientDetails", res.resource[0], (data) => {
                // this.appService._currentSessionData.getPatientDetails = data;
              });
              this.storageService.setData("current_facility", { facility_id: res.resource[0].current_facility_id, facility_name: res.resource[0].current_facility_name }, () => {
                console.log("current facility details data saved alredy")
              })
            }
          })
        }
        this.alertPermission();
        this.preferenceService.getHeaderPreferences(() => { });
        this.preferenceService.getCommonConfig(() => { });
        this.accessibilityService.loadUserPreference();
        this.storageService.setData('currentUserGroup', response?.user_group? response?.user_group:'', () => {
          console.log('User Group Name Saved');
        });
      });
    } else {
      this.loader.hideSpinner();
      if (super_app_url == "/")
        this.router.navigate([this.appService._appData.DEFAULT_APPLICATION + '/dashboard']);
      else {
        let url = window.location.origin + super_app_url + this.appService._appData.DEFAULT_APPLICATION + "/dashboard";
        this.baseService.redirect(url, "_self").then(() => { });
      }

    }
  }

  addNativeFCM() {
    if (this.appService.checkNativeApp()) {
      var nativefcm = this.appService.readCookie("nativefcm");
      if (nativefcm != "") {
        this.messagingService.setnotificationtoDb(this.authenticationService.getCurrentUser().user_id, nativefcm, false);
      }
    }
  }


  private alertPermission() {
    if (Notification) {
      if (Notification.permission !== 'granted')
        this.alerts.info("For better experience please turn on notification");
    } else
      this.alerts.info("Notification is not supported in this version");
  }

  installApp() {
    var installRes = this.utilService.isInstallable(pwaPrompt);
    if (installRes) {
      if (installRes != 1) {
        const config: ModalOptions = {
          backdrop: true,
          ignoreBackdropClick: false,
          keyboard: true,
          animated: true,
          initialState: {
            data: installRes
          }
        };
        this.bsModalService.show(AppAlertComponent, config);
      } else {
        pwaPrompt.prompt();
      }
    }
  }

  isInstallable() {
    return (this.utilService.isInstallable(pwaPrompt) != 0);
  }

  currentYear() {
    return new Date().getFullYear()
  }

  encrypt(loginInfo) {
    loginInfo = { ...loginInfo };//making clone to avoid multiple encryption
    try {
      var account_url = loginInfo['account_url'].split('.');
      if (account_url[0].length < 16) {
        account_url[0] = account_url[0] + "0000000000000000".substring(0, (16 - account_url[0].length));
      } else {
        account_url[0] = account_url[0].substring(0, 16);
      }
      loginInfo['login_id'] = this.appService.encryptText(account_url[0], loginInfo['login_id']);
      loginInfo['password'] = this.appService.encryptText(account_url[0], loginInfo['password']);
      return loginInfo;
    } catch (e) {
      return loginInfo;
    }
  }

  getCaptchaResourceDef(callback?: (question: any) => void): void {
    this.baseService.getResourceDef('captcha_store', (data) => {
      const captcha = this.formService.buildFormGroup(this, data.form);
      callback?.(captcha && captcha.length && captcha[0].questions && captcha[0].questions.length ? captcha[0].questions[0] : null);
    });
  }

  getCaptchaStyle(elementRef: ElementRef, renderer: Renderer2): void {
    if (this.captchaObserver) {
      this.captchaObserver.disconnect();
      this.captchaObserver = undefined;
    }
    const host: HTMLElement = elementRef.nativeElement;
    const container: HTMLElement = host.querySelector('.captcha-generate');
    if (container && this.styleCaptchaWidget(container, renderer)) {
      return;
    }
    this.captchaObserver = new MutationObserver(() => {
      const el: HTMLElement = container || host.querySelector('.captcha-generate');
      if (el && this.styleCaptchaWidget(el, renderer)) {
        this.captchaObserver.disconnect();
        this.captchaObserver = undefined;
      }
    });
    this.captchaObserver.observe(host, { childList: true, subtree: true });
  }

  disconnectCaptchaObserver(): void {
    if (this.captchaObserver) {
      this.captchaObserver.disconnect();
      this.captchaObserver = undefined;
    }
  }

  styleCaptchaWidget(container: HTMLElement, renderer: Renderer2): boolean {
    const questionDiv: HTMLElement = container.querySelector('#captcha_ques.form-element');
    if (questionDiv) {
      renderer.setStyle(questionDiv, 'display', 'flex');
      renderer.setStyle(questionDiv, 'align-items', 'center');
      renderer.setStyle(questionDiv, 'justify-content', 'flex-start');
      renderer.setStyle(questionDiv, 'width', '100%');
      renderer.setStyle(questionDiv, 'flex-wrap', 'wrap');
      renderer.setStyle(questionDiv, 'padding-left', '0');
      renderer.setStyle(questionDiv, 'padding-right', '5px');

      const errorMsg: HTMLElement = questionDiv.querySelector(':scope > span.input-error-msg');
      if (errorMsg) {
        renderer.setStyle(errorMsg, 'font-size', '13px');
        renderer.setStyle(errorMsg, 'top', '-10px');
        renderer.setStyle(errorMsg, 'left', '7px');
        renderer.setStyle(errorMsg, 'padding', '0 5px');
      }

      const detailError: HTMLElement = questionDiv.querySelector(':scope > div.input-detail-error');
      if (detailError) {
        renderer.setStyle(detailError, 'bottom', '4px');
        renderer.setStyle(detailError, 'right', '12px');
        renderer.setStyle(detailError, 'padding', '4px 0');
        renderer.setStyle(detailError, 'color', 'red');
        renderer.setStyle(detailError, 'top', '-12px');
      }
    }

    const reCaptchaEl: HTMLElement = container.querySelector('re-captcha');
    if (!reCaptchaEl) {
      return false;
    }
    renderer.setStyle(reCaptchaEl, 'width', '100%');
    const reCaptchaInnerDiv = reCaptchaEl.querySelector(':scope > div') as HTMLElement;
    if (reCaptchaInnerDiv) {
      renderer.setStyle(reCaptchaInnerDiv, 'width', 'auto');
      renderer.setStyle(reCaptchaInnerDiv, 'height', '78px');
    }
    const iframe: HTMLElement = reCaptchaEl.querySelector('iframe');
    if (iframe) {
      renderer.setStyle(iframe, 'width', '100%');
    }
    return !!iframe;
  }
  // showLoginForm() {
  //   return this.showLoginFormValue;
  // }

}
